Object.defineProperty(exports, "__esModule", {
  value: true
});

// Customizable Area Start
exports.httpGetMethod = "GET";
exports.httpPatchMethod =  "PATCH";

exports.getNotificationAPIEndPoint = "notifsettings/notification_settings";
exports.updateNotificationAPIEndPoint = "notifsettings/notification_settings/";
exports.updateNotificationGroupAPIEndPoint = "notifsettings/groups/";
exports.updateNotificationSubGroupAPIEndPoint = "notifsettings/subgroups/";

exports.notificationApiContentType = "application/json";

// Customizable Area End